import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Instalacion } from '../../types/Instalacion';

interface InstalacionState {
  instalaciones: Instalacion[];
  instalacionSelected: Instalacion;
  loading: boolean;
}

export const instalacionInitial: Instalacion = {
  id: 0,
  nombre: '',
  domicilio: '',
  telefono: '',
  localidad: '',
  idEmpresaGestora: 0,
};

const initialState: InstalacionState = {
  instalaciones: [],
  instalacionSelected: instalacionInitial,
  loading: false,
};

export const instalacionSlice = createSlice({
  name: 'instalacion',
  initialState,
  reducers: {
    isLoading: (state, data: PayloadAction<boolean>): void => {
      state.loading = data.payload;
    },
    loadDataInstalacion: (
      state,
      data: PayloadAction<Instalacion>
    ): void => {
      state.instalacionSelected = data.payload;
      state.loading = false;
    },
    loadListInstalacion: (
      state,
      data: PayloadAction<Instalacion[]>
    ): void => {
      state.instalaciones = data.payload;
      state.loading = false;
    },
  },
});

export const { isLoading, loadDataInstalacion, loadListInstalacion } =
  instalacionSlice.actions;
export default instalacionSlice.reducer;
